import {
  userLogin,
  getUserByToken,
  verificationCodeLogin,
  getSysUserUserMenuTreeAndRightList,
  GetUserHospitalList,
  getSysAppById,
  hisTokenApi,
  logoutOpenId,
  tokensm2,
  usercodesm2,
  getApiVersion,
  GetConfigList
} from "@/api/api.js"
import {
  getFileRead
} from "@/api/fileapi"
import {
  getTokenInfo,
  setTokenInfo,
  removeTokenInfo,
  setUserInfo,
  getUserInfo,
  removeUserInfo,
  setExpires,
  getExpires,
  removeExpires,
  setRefreshExpires,
  removeRefreshExpires,
  setMenu,
  removeMenu,
  getTags,
  setTags,
  removeTags,
  removeOperateTime,
  setLogoutFlag,
  getRefreshToken,
  setRefreshToken,
  removeRefreshToken
} from '@/utils/auth'
// import { hex_md5} from '@/utils/md5.js'
import sm2 from '@/utils/sm2.js'
import router from '@/router'
import MenuUtils from "@/utils/menuUtils.js"
import menuCorrect from "@/utils/menuCorrect.js"
import { default as asyncMenu, defaultMenu } from "@/router/asyncMenu.js"
import menulistjson from "@/data/menulistjson.js"
import { sysAppId, isLocal } from "@/settings.js"
import avatar from "@/assets/images/avatar2.jpg"
import { Message } from "element-ui"
import aes from "@/utils/aes"
import axios from 'axios'
const refreshTime = window.g.EXPIRE_TIME || 5

// 头像是否可直接用于 <img>：base64(data:) 或 http(s) 链接。
// 服务器文件路径需经 getFileRead 接口读取转 base64，不能直接显示，此时用默认头像占位。
const isDisplayableAvatar = (p) => !!p && (String(p).indexOf('data:') === 0 || /^https?:\/\//i.test(p))

const _tokenInfo = getTokenInfo()
const userInfo = !getUserInfo() ? {} : getUserInfo()
const _tags = !getTags() ? [] : getTags()
const _refreshToken = getRefreshToken()
const getDefaultState = () => {
  return {
    userInfo: userInfo,
    userName: userInfo.userName,
    userCode: userInfo.userCode,
    hospitalId: userInfo.hospitalId,
    hospitalCode: userInfo.hospitalCode,
    hospitalName: userInfo.hospitalName,
    departmentId: userInfo.deptCode,
    departmentName: userInfo.deptName,
    tokenInfo: !_tokenInfo ? '' : _tokenInfo,
    token: !_tokenInfo ? '' : _tokenInfo.accessToken,
    refreshToken:_refreshToken,
    tokenType: '',
    tokenExpires: getExpires() * 1,
    avatar: isDisplayableAvatar(userInfo.userPhoto) ? userInfo.userPhoto : avatar,
    id: userInfo.id,
    //判断更新token有效期，多请求并行请求时拦截后面的请求更新token有效期
    expiresFlag: false,
    //页面按钮权限
    tags: _tags,
    // 是否主责 一体化
    iszzYTH: false
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_TOKENEXPIRES: (state, expires) => {
    state.tokenExpires = expires
  },
  SET_REFRESHTOKEN:(state, refreshToken)=>{
    state.refreshToken = refreshToken
  },
  SET_NAME: (state, name) => {
    state.userName = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_TOKENINFO: (state, tokeninfo) => {
    state.tokenInfo = tokeninfo
    state.token = tokeninfo.accessToken
    state.tokenType = tokeninfo.type
    state.tokenExpires = tokeninfo.expires
  },
  SET_USERINFO: (state, info) => {
    state.userInfo = info
    state.userName = info.userName
    state.userCode = info.userCode
    state.hospitalId = info.hospitalId
    state.hospitalCode = info.hospitalCode
    state.hospitalName = info.hospitalName
    state.departmentId = info.deptCode
    state.departmentName = info.deptName
    state.avatar = isDisplayableAvatar(info.userPhoto) ? info.userPhoto : avatar
    state.id = info.id
  },
  SET_EXPIRESFLAG: (state, flag) => {
    state.expiresFlag = flag
  },
  SET_TAGS: (state, tags) => {
    state.tags = tags
  },
  SET_ISZZYTH: (state, iszz) => {
    state.iszzYTH = iszz
  }
}

const actions = {
  // 用户登录
  login({
    dispatch,
    commit
  }, loginInfo) {
    setLogoutFlag(false)
    if (isLocal) {
      return new Promise(async (resolve, reject) => {
        await dispatch('loginLocal')
        resolve()
      })
    }
    const {
      account,
      password,
      validateKey,
      validateCode
    } = loginInfo
    // const pwd =  hex_md5(password).toUpperCase();
    const pwd = sm2.SM2Encrypt(password)
    return new Promise((resolve, reject) => {
      userLogin({
        userCode: account.trim(),
        userPwd: '04'+pwd,
        pwdType:1,
        validateKey:validateKey,//验证码key
        validateCode:validateCode//验证码code
      }).then(async response => {
        if (response && (response.code == 10000 || response.Code == 10000)) {
          const {
            content
          } = response
         await dispatch('setTokenData',content)
          resolve()
        } else {
          reject()
        }
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  // 手机号验证码登录
  loginCode({
    dispatch,
    commit
  }, data) {
    setLogoutFlag(false)
    if (isLocal) {
      return new Promise(async (resolve, reject) => {
        await dispatch('loginLocal')
        resolve()
      })
    }
    const {
      mobile,
      code,
    } = data
    return new Promise((resolve, reject) => {
      verificationCodeLogin({
        telephone: mobile.trim(),
        verificationCode: code,
        sysAppId: sysAppId,
        codeType: 1 // 验证码类型：0注册；1登录；2忘记密码；3修改信息；4其他，默认1
      }).then(async response => {
        if (response && (response.code == 10000 || response.Code == 10000)) {
          const {
            content
          } = response
          commit('SET_TOKENINFO', content)
          setTokenInfo(content)
          setExpires(content.expires)
          // await dispatch('getInfoLocal')
          // await dispatch('getMenuLocal')
          // 登录的时候设置客户端过期时间
          let refreshExpires = Date.parse(new Date()) / 1000 + refreshTime * 24 * 3600 // 换算成秒
          setRefreshExpires(refreshExpires)
          dispatch('expiresflag', false)
          await dispatch('getInfo')
          await dispatch('getMenu')
          resolve(response)
        } else {
          reject(response)
        }
      })
      // .catch(error => {
      //   reject(error)
      // })
    })
  },
  getHospitalList({dispatch}){//获取医院列表
    return new Promise((resolve,reject)=>{
        GetUserHospitalList().then(res=>{
            if(res && res.code === 10000){
                resolve()
            }else{
                // dispatch('logout')
                reject()
            }
        }).catch(()=>{
            dispatch('logout')
            reject()
        })
    })
  },
 async setTokenData({dispatch,commit},content){
    commit('SET_TOKENINFO', content)
    setTokenInfo(content)
    setExpires(content.expires)
    // 登录的时候设置客户端过期时间
    let refreshExpires = Date.parse(new Date()) / 1000 + refreshTime * 24 * 3600 // 换算成秒
    setRefreshExpires(refreshExpires)
    dispatch('expiresflag', false)
    await dispatch('getInfo')
    dispatch('getHospitalList')
    await dispatch('getMenu')
    dispatch('getApiVersion')
    await dispatch('getSysConfig')
  },

  // 获取用户信息
  getInfo({
    commit,
    dispatch
  }) {
    return new Promise((resolve, reject) => {
      getUserByToken().then(response => {
        const {
          content
        } = response
        if (response) {
          // 持久化用户信息：userPhoto 保持为文件路径，避免头像 base64 撑爆 localStorage(QuotaExceededError)
          commit('SET_USERINFO', content)
          const info = JSON.stringify(content)
          setUserInfo(info)
          // 头像 base64 仅存内存(state.avatar)，不写入 localStorage
          dispatch('loadAvatar')
          resolve(content)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 加载头像：从 userInfo.userPhoto 路径读取 base64 存入内存(state.avatar)；刷新页面时重新拉取
  loadAvatar({ commit, state }) {
    const photoPath = state.userInfo && state.userInfo.userPhoto
    if (!photoPath) return
    // 已是可直接显示的 base64/链接则直接用，无需再请求
    if (isDisplayableAvatar(photoPath)) {
      commit('SET_AVATAR', photoPath)
      return
    }
    getFileRead(photoPath).then(data => {
      // 读取失败时 getFileRead 返回 ''/false，保持默认头像
      if (data) commit('SET_AVATAR', data)
    })
  },
  // 获取用户菜单
  getMenu({
    dispatch,
    commit
  }) {
    let params = {
      HospitalCode: '',//this.$store.state.user.hospitalCode,
      SysAppId: sysAppId
    };
    return new Promise((resolve, reject) => {
      // getUserMenuTreeList(params).then(response => {
      getSysUserUserMenuTreeAndRightList(params).then(response => {
        // var response = {
        //   code: 10000,
        //   Menus: menulistjson
        // };
        if (response && response.code == 10000) {
          //遍历更新菜单格式
          if(!window.g.authorityJudge || (response.content.list && response.content.list.length>0)){
              let menuData = menuCorrect(response.content.list)  //menulistjson //
              if (menuData != null) {
                // 遍历添加本地，菜单隐藏路由配置
                menuData = menuData.map((item) => {
                  const asyncMenuIdx = asyncMenu.findIndex((value) => value.path == item.path);
                  if (asyncMenuIdx >= 0) {
                    const _child = asyncMenu[asyncMenuIdx].children
                    asyncMenu.splice(asyncMenuIdx, 1);
                    item.children = item.children.concat(_child);
                  }
                  return item;
                });
                menuData = menuData.concat(asyncMenu)
                setMenu(JSON.stringify(menuData));
              }
              router.options.routes = [];
              let routes = [];
              if(menuData.length===0) {
                // 设置默认主页菜单
                menuData = defaultMenu
              }
              if (menuData.length > 0) {
                MenuUtils(routes, menuData);
                router.options.routes = Object.assign(
                  router.options.routes,
                  routes
                );
                router.addRoutes(routes);
              }
          }else{
            Message.error('暂无权限~')
            dispatch('logout')
          }
          resolve(response)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  //刷新令牌并获取数据
  setNewTokenInfoAndGetData({
    commit,
    dispatch
  },info){
    return new Promise(async resolve => {
      await dispatch('setNewTokenInfo',info)
      await dispatch('getInfo')
      await dispatch('getMenu')
      resolve()
    })
  },
  // 刷新令牌
  setNewTokenInfo({
    commit,
    dispatch
  }, info) {
    return new Promise(async resolve => {
      setTokenInfo(info);
      setExpires(info.expires);
      commit('SET_TOKENINFO', info)
      commit('SET_TOKENEXPIRES', info.expires)
      if(info.refreshToken){
          commit('SET_REFRESHTOKEN', info.refreshToken)
          setRefreshToken(info.refreshToken);
      }
      // 登录的时候设置客户端过期时间
      let refreshExpires = Date.parse(new Date()) / 1000 + refreshTime * 24 * 3600 // 换算成秒
      setRefreshExpires(refreshExpires)
      resolve()
    })
  },

  // 退出登录
 logout({
    commit,
    state,
    dispatch
  }) {
    return new Promise(async resolve => {
        if(state.userCode && window.g.LOGINTYPES && window.g.LOGINTYPES.includes('otherLogin')){
            console.log('000000')
           await logoutOpenId({UserCode:state.userCode}).then(async response=>{
                if(response && response.code == 10000){
                    await dispatch('logoutClear')
                    console.log('22222')
                    resolve()
                }
              })
            console.log('33333')
        }else{
           await dispatch('logoutClear')
            resolve()
        }
    })
  },
  logoutClear({commit}){
    return new Promise((resolve) => {
        removeTokenInfo() // 移除token
        removeUserInfo() //移除用户信息
        removeExpires()
        removeRefreshExpires()
        removeTags()
        removeMenu()
        removeRefreshToken()
        localStorage.removeItem('hospitalOptions')
        commit('RESET_STATE')
        removeOperateTime()
        setLogoutFlag(true)
        console.log('111111')
        resolve()
    })
  },

  // remove token
  resetToken({
    commit
  }) {
    return new Promise(resolve => {
      removeTokenInfo()
      commit('RESET_STATE')
      resolve()
    })
  },

  // 设置 expiresflag
  expiresflag({ commit }, flag) {
    commit('SET_EXPIRESFLAG', flag)
  },

  // 设置 用户权限
  resetTags({ commit }, tags) {
    setTags(tags)
    commit('SET_TAGS', tags)
  },
  // 设置 主责
  resetIszz({ commit }, iszz) {
    commit('SET_ISZZYTH', iszz)
  },

  // 本地登录
  loginLocal({ dispatch, commit }) {
    return new Promise(async (resolve, reject) => {
      const content = {
        accessToken: 'local-login-token',
        expires: Math.floor(new Date().getTime() / 1000) + 18000,
        type: 'local'
      }
      commit('SET_TOKENINFO', content)
      setTokenInfo(content)
      setExpires(content.expires)
      // 登录的时候设置客户端过期时间
      let refreshExpires = Date.parse(new Date()) / 1000 + refreshTime * 24 * 3600 // 换算成秒
      setRefreshExpires(refreshExpires)
      await dispatch('getInfoLocal')
      await dispatch('getMenuLocal')
      resolve()
    })
  },
  getInfoLocal({
    commit
  }) {
    return new Promise((resolve, reject) => {
      const content = {
        userName: 'local',
        userCode: 'local',
        hospitalId: 'local',
        hospitalCode: 'local',
        hospitalName: 'local',
        id: 'local'
      }
      commit('SET_USERINFO', content)
      const info = JSON.stringify(content)
      setUserInfo(info)
      resolve()
    })
  },
  getMenuLocal({
    commit
  }) {
    return new Promise((resolve, reject) => {
      //遍历更新菜单格式
      let menuData = menulistjson
      if (menuData != null) {
        // 遍历添加本地，菜单隐藏路由配置
        menuData = menuData.map((item) => {
          const asyncMenuIdx = asyncMenu.findIndex((value) => value.path == item.path);
          if (asyncMenuIdx >= 0) {
            const _child = asyncMenu[asyncMenuIdx].children
            asyncMenu.splice(asyncMenuIdx, 1);
            item.children = item.children.concat(_child);
          }
          return item;
        });
        menuData = menuData.concat(asyncMenu)

        menuData = JSON.stringify(menuData) //所有的key转换成小写
        setMenu(menuData);
      }
      router.options.routes = [];
      let routes = [];
      if (menuData.length > 0) {
        MenuUtils(routes, menuData);
        router.options.routes = Object.assign(
          router.options.routes,
          routes
        );
        router.addRoutes(routes);
      }
      resolve()
    })
  },
  hisLogin({dispatch,commit},params){
    return new Promise(async (rs,rj)=>{
        setLogoutFlag(false)
        commit('SET_TOKEN',params.token)
        let p = {
            hospitalCode:params.hospitalCode,
            token:params.token
        }
        await hisTokenApi(p).then(async (r)=>{
            if(r){
                let tokenInfo = r.content
                let url = ''
                await dispatch('setTokenData',tokenInfo)
                if(params.appId){//获取系统对应url
                    let appRes = await getSysAppById({id:params.appId})
                    if(appRes && appRes.code === 10000){
                        url = appRes.content.appUrl
                    }
                }
                let tokenEncrypt = encodeURIComponent(aes.AESEncrypt(JSON.stringify(tokenInfo)))
                rs({token:tokenEncrypt,url})
            }
        })
    })
  },
  sm2login({commit,dispatch},params){
    return new Promise(async (rs,rj)=>{
        setLogoutFlag(false)
        let p = {
            hospitalCode:params.hospitalCode || params.hospitalcode,
            data:params.data,
            isDefaultSms2:true
        }
        await tokensm2(p).then(async (r)=>{
            if(r){
                let tokenInfo = r.content
                await dispatch('setTokenData',tokenInfo)
                rs()
            }else{
                rj()
            }
        }).catch(()=>{
            rj()
        })
    })
  },
  lzHisLogin({commit,dispatch},params){
    return new Promise(async (rs,rj)=>{
        setLogoutFlag(false)
        let p = {
            hospitalCode:params.hospitalCode || params.hospitalcode,
            data:params.data,
            isDefaultSms2:true
        }
        await usercodesm2(p).then(async (r)=>{
            if(r){
                let tokenInfo = r.content
                await dispatch('setTokenData',tokenInfo)
                rs()
            }else{
                rj()
            }
        }).catch(()=>{
            rj()
        })
    })
  },
  getApiVersion() {
      getApiVersion().then(res => {
        if (res) {
          localStorage.setItem('apiVersion', res.content)
        }
      })
  },
  getSysConfig() {
    return new Promise(async(resolve, reject) => {
        await forceReloadJS(process.env.NODE_ENV === 'production' ? '/config.js':'/static/config.js');
        GetConfigList({SysAppId:sysAppId}).then(res => {
            if (res && res.code === 10000) {
                let config = res.content.list
                if (config) {
                    config.forEach(item => {
                        if(item.isEnabled && item.valueType !== 2 && item.configValue !== ''){//字符型
                            window.g[item.configName] = JSON.parse(item.configValue)
                        }else if(item.isEnabled){
                            window.g[item.configName] = item.configValue
                        }
                    })
                    localStorage.setItem('sysConfig', JSON.stringify(window.g))
                }
            }
            resolve()
        }).catch(() => {
            reject()
        })
    })

    
    function forceReloadJS(url) {
        return new Promise((resolve, reject) => {

            const script = document.createElement('script');
            const timestamp = new Date().getTime();
            script.src = `${url}?t=${timestamp}`; // 时间戳防止缓存
            script.async = true;

            script.onload = ()=>{
                // 清理script标签
            document.head.removeChild(script);
            resolve()
            }

            // 4. 设置加载失败回调
            script.onerror = () => {
            reject(new Error('无法加载配置文件'));
            document.head.removeChild(script);
            };
            
            // 5. 添加到DOM开始加载
            document.head.appendChild(script);
        })
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js